import React from 'react'
import Header from './components/Header';
import Footer from './components/Footer';
import { useState,useEffect } from 'react';
import './styles/motoStyles.css';
import lotus from '../src/images/lotus.png';

const Dispute = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

    
    useEffect(() => {
      const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  return (
    <div>
      <div className={`moto ${fadeOut ? 'fade-out' : ''}`}>
        <h1>Dispute Resolution here at KWA</h1>
      </div>
      <Header scrolled={scrolled}/>
      <div className='justify-content-center d-flex align-items-center w-100 fs-4' style={{minHeight:'100vh',padding:'10%',paddingTop: '5%',paddingBottom: '5%'}}>
        <img src={lotus} alt='' className='lotus'></img>
        <div className=''><p>Welcome to <span className="kwa">KWA</span>, a distinguished legal entity renowned for its expertise in <span className="highlight">dispute resolution</span> under <span className="highlight">Indian laws</span>. </p>
        <br />
        <p><span className="highlight">Disputes</span> are an inevitable aspect of <span className="highlight">commercial</span> and <span className="highlight">personal transactions</span>, requiring adept legal navigation to achieve optimal resolutions. Our firm specializes in a myriad of dispute resolution mechanisms, including <span className="highlight">negotiation</span>, <span className="highlight">mediation</span>, <span className="highlight">arbitration</span>, and <span className="highlight">litigation</span>, tailored to suit the unique needs of each case.</p>
        <br />
        <p>In negotiation, we employ strategic communication and bargaining techniques to facilitate mutually beneficial agreements between parties, fostering cooperation and preserving relationships. Our mediation services offer a neutral ground for parties to engage in facilitated discussions, guided by experienced mediators, to reach amicable settlements outside of court.</p>
        <br />
        <p>For complex disputes demanding impartial adjudication, our arbitration team possesses extensive experience in representing clients in both domestic and international <span className="highlight">arbitration proceedings</span>. We ensure procedural fairness and enforceability of awards in accordance with <span className="highlight">Indian arbitration laws</span> and <span className="highlight">international conventions</span>.</p>
        <br />
        <p>In contentious matters necessitating judicial intervention, our litigation advocates advocate zealously for our clients' interests before various forums, including district courts, high courts, and specialized tribunals. Our litigation prowess is underpinned by a comprehensive understanding of substantive and procedural laws, coupled with strategic litigation strategies to achieve favourable outcomes.</p>
        <br />
        <p>At <span className="kwa">KWA</span>, our commitment to excellence and client satisfaction distinguishes us as leaders in dispute resolution, providing effective and efficient legal solutions tailored to our clients' specific needs and objectives.</p></div>
      </div>
      <Footer />
    </div>
  )
}

export default Dispute
